module.exports = __webpack_public_path__ + "static/media/iq.0325674f.svg";